const news = [
  {
    id: 1,
    date: '20 April, 2021',
    title:
      'System predicts transaction volume and help to leverage timeframe opportunities to gain the profit ',
    image: '/images/temp/story/news-1.jpg',
  },
  {
    id: 2,
    date: '20 April, 2021',
    title:
      'System predicts transaction volume and help to leverage timeframe opportunities to gain the profit ',
    image: '/images/temp/story/news-2.jpg',
  },
  {
    id: 3,
    date: '20 April, 2021',
    title:
      'System predicts transaction volume and help to leverage timeframe opportunities to gain the profit ',
    image: '/images/temp/story/news-3.jpg',
  },
];

export default news;
